import CheckItem from './check-item.vue'

export default CheckItem
